import React from 'react';

function CustomTable({ headers, rows, theme, color, selectedStyle }) {
  // Calculate rgba value
  function hexToRgba() {
    const opacity = 0.3;
    const [r, g, b] = color.match(/\w\w/g).map((x) => parseInt(x, 16));
    if (theme === "custom") {
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }
  }

  return (
    <table className="layout-table">
      <thead>
        <tr>
          {headers.map((header, index) => (
            <th key={index}>{header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <td
                key={cellIndex}
                className={"editable"}
                style={{
                  // backgroundColor: rowIndex % 2 === 1 && hexToRgba(),
                  borderRight:
                    theme === "dark" && cellIndex !== row.length - 1
                      ? "2px solid #f8ffef"
                      : "",
                }}
              >
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default CustomTable;
